import { IFormFieldType } from '@/widgets/create-widget'
import { MediaType } from '@/constants/constants'

const FounderSectionSchema: { [key: string]: IFormFieldType } = {
  founderSection: {
    type: 'Object',
    label: 'Founder Section',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      founderMessage: {
        type: 'String',
        label: 'Founder Message',
        required: false,
      },
      founderImage: {
        type: 'Media',
        mediaTypes: [MediaType.IMAGE],
        label: 'Founder Image',
        required: false,
      },
      founderName: {
        type: 'String',
        label: 'Founder Name',
        required: false,
      },
      founderDesignation: {
        type: 'String',
        label: 'Founder Designation',
        required: false,
      },
    },
  },
}

export default FounderSectionSchema

export type FounderSectionProps = {
  founderSection: {
    heading: string
    founderMessage: string
    founderImage: string
    founderName: string
    founderDesignation: string
  }
}

export const FounderSectionDefaultValues: FounderSectionProps = {
  founderSection: {
    heading: 'From Alakh Sir’s Desk',
    founderName: 'Alakh Pandey',
    founderMessage:
      "At Physicswallah, we believe education transforms lives. We're proud of the difference we've made, and now we're focusing on the foundational years – the time when a child's love of learning begins. We envision a future where every young learner discovers the joy of learning and where dreams take flight. We're committed to building that future, together.",
    founderImage: 'https://static.pw.live/production-curiousjr-fundoo/static/images/Landing-Alakh.png',
    founderDesignation: 'Founder, Physicswallah',
  },
}
